/**
 * Generated by orval 🍺
 * Do not edit manually.
 * PF Appointments API
 * appointments-api v1. Generated from the route table; do not edit by hand (pnpm openapi).
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod'

export const incidentPageItemsItemClinicIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
)
export const incidentPageItemsItemDownMinutesMin = 0
export const incidentPageItemsItemDownMinutesMax = 9007199254740991

export const incidentPageItemsItemEndedAtOneRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
)
export const incidentPageItemsItemIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
)
export const incidentPageItemsItemStartedAtRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
)
export const incidentPagePageMax = 9007199254740991

export const incidentPagePageSizeMax = 100

export const incidentPageTotalMin = 0
export const incidentPageTotalMax = 9007199254740991

export const IncidentPage = zod.object({
  items: zod.array(
    zod.object({
      clinic: zod
        .object({
          id: zod.uuid().regex(incidentPageItemsItemClinicIdRegExp),
          name: zod.string(),
          slug: zod.string(),
        })
        .optional(),
      component: zod.enum(['pf_keeper_app', 'pf_session']),
      downMinutes: zod.int().min(incidentPageItemsItemDownMinutesMin).max(incidentPageItemsItemDownMinutesMax),
      endedAt: zod.union([zod.iso.datetime({ offset: true }).regex(incidentPageItemsItemEndedAtOneRegExp), zod.null()]),
      id: zod.uuid().regex(incidentPageItemsItemIdRegExp),
      level: zod.enum(['minor', 'major']),
      resolution: zod.string().nullable(),
      startedAt: zod.iso.datetime({ offset: true }).regex(incidentPageItemsItemStartedAtRegExp),
      title: zod.string(),
    }),
  ),
  page: zod.int().min(1).max(incidentPagePageMax),
  pageSize: zod.int().min(1).max(incidentPagePageSizeMax),
  total: zod.int().min(incidentPageTotalMin).max(incidentPageTotalMax),
})

export type IncidentPage = zod.input<typeof IncidentPage>
export type IncidentPageOutput = zod.output<typeof IncidentPage>
